import React from 'react'
import { View } from 'react-native'

import { SafeAreaView } from 'react-native-safe-area-context'
import { StatusBar } from 'expo-status-bar'
import { router } from 'expo-router'

import { DS } from '@/design-system'

import { AvatarEditor } from '@/screens/profile-screen/edit/AvatarEditor'
import { Header } from '@/components/Mini/Header'

import { useHandleCancel } from "@/screens/profile-screen/edit/AvatarModule"

function AvatarScreen(){
  return (
    <SafeAreaView style={{flex:1, backgroundColor: DS.palette['Brand/Cream']}} edges={['top', 'bottom']}>

        <StatusBar style="dark" />

        <View style={{flex:1}}>
          <EditAvatarScreenHeader />
          <View style={{marginHorizontal:24, flex:1, paddingBottom: 16}}>
            <AvatarEditor />
          </View>
        </View>

    </SafeAreaView>
  )
}





function EditAvatarScreenHeader(){

  const handleCancel = useHandleCancel()

  const onPressCancel = () => {
    handleCancel()
    router.back()
  }

  const icon = 'Global/Black'
  const accent = 'Global/Black'

  return (
    <Header theme={{icon, accent}} variant="Heading 3/Medium" title="Avatar" showKey={false} handler={onPressCancel}/>
  )
}

export default AvatarScreen

